import React from "react";

const InvCusExpEmptyIcon = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  return (
    <>
 <svg
    xmlns="http://www.w3.org/2000/svg"
    width={152}
    height={163}
    fill="none"
    {...props}
  >
    <path
      fill="url(#a)"
      d="M76.001 151.901c41.947 0 75.951-34.004 75.951-75.95C151.952 34.004 117.948 0 76.002 0 34.054 0 .05 34.004.05 75.95c0 41.947 34.004 75.951 75.95 75.951Z"
    />
    <g filter="url(#b)">
      <path
        fill="#fff"
        d="M119.548 43.541h-87.09a5.063 5.063 0 0 0-5.063 5.063v106.331a5.064 5.064 0 0 0 5.063 5.064h87.09a5.063 5.063 0 0 0 5.063-5.064V48.605a5.063 5.063 0 0 0-5.063-5.064Z"
      />
    </g>
    <path
      fill="#B4DAFF"
      d="M65.875 58.734h-26.33a3.038 3.038 0 1 0 0 6.076h26.33a3.038 3.038 0 1 0 0-6.076Z"
    />
    <path
      fill="#DFEAFB"
      d="M84.103 71.898H39.546a3.038 3.038 0 0 0 0 6.077h44.557a3.038 3.038 0 0 0 0-6.077Z"
    />
    <path
      fill="#B4DAFF"
      d="M65.875 86.078h-26.33a3.038 3.038 0 0 0 0 6.076h26.33a3.038 3.038 0 0 0 0-6.076Z"
    />
    <path
      fill="#DFEAFB"
      d="M84.103 99.242H39.546a3.038 3.038 0 1 0 0 6.076h44.557a3.038 3.038 0 1 0 0-6.076Z"
    />
    <path
      fill="#B4DAFF"
      d="M65.875 113.42h-26.33a3.038 3.038 0 1 0 0 6.076h26.33a3.038 3.038 0 1 0 0-6.076Z"
    />
    <path
      fill="#DFEAFB"
      d="M84.103 126.584H39.546a3.038 3.038 0 1 0 0 6.076h44.557a3.038 3.038 0 1 0 0-6.076Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={76.001}
        x2={76.001}
        y1={0}
        y2={151.901}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E3ECFA" />
        <stop offset={1} stopColor="#DAE7FF" />
      </linearGradient>
      <filter
        id="b"
        width={105.443}
        height={124.686}
        x={23.28}
        y={37.37}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-2.057} />
        <feGaussianBlur stdDeviation={2.057} />
        <feColorMatrix values="0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_50361_126584"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_50361_126584"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
    </>
  );
};

export default InvCusExpEmptyIcon;
